import { ReactNode } from 'react';

import { AllSystemProps } from 'shared/styles/props';
import { theme } from 'shared/styles/theme';
import { Box } from 'shared/ui/Box';
import { Skeleton } from 'shared/ui/Skeleton';
import { FormFieldLabel } from 'shared/ui/Styled';

import styled from '@emotion/styled';

export const RootStyled = styled(Box)<{
  align: 'vertical' | 'horizontal';
  isHideMargin?: boolean;
}>`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 100%;
  gap: 12px;
  margin-bottom: ${({ isHideMargin }) => (isHideMargin ? 0 : theme.space[7])};
  ${({ align }) =>
    align === 'vertical' &&
    `
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
      `};
`;

type Props = {
  children: ReactNode;
  label?: string;
  width?: AllSystemProps['width'];
  align?: 'vertical' | 'horizontal';
  boxStyles?: AllSystemProps;
  isHideMargin?: boolean;
  labelMarginBottom?: number;
  height?: string;
};

export const FormField = ({ children, label, width, align = 'horizontal', boxStyles, isHideMargin }: Props) => (
  // @ts-ignore TODO: починить типизацию
  <RootStyled align={align} isHideMargin={isHideMargin} {...boxStyles} className='form-field'>
    <FormFieldLabel>{label}</FormFieldLabel>
    <Box width={width}>{children}</Box>
  </RootStyled>
);

export const GridFormField = ({ children, label, align = 'horizontal', labelMarginBottom = 8, height }: Props) => {
  if (align === 'vertical') {
    return (
      <Box gridColumn='span 2'>
        {label && <FormFieldLabel>{label}</FormFieldLabel>}
        <Box width='100%'>{children}</Box>
      </Box>
    );
  }

  return (
    <>
      {label && (
        <FormFieldLabel height={height} mb={labelMarginBottom}>
          {label}
        </FormFieldLabel>
      )}
      <Box width='100%'>{children}</Box>
    </>
  );
};

type OptionalFieldProps = {
  value?: unknown;
} & Props;

export const OptionalField = ({ value, ...props }: OptionalFieldProps) => (value ? <FormField {...props} /> : null);

export const FormFieldSkeleton = (props: AllSystemProps) => <Skeleton height={25} width='50%' mt={32} {...props} />;
